
<template>
  
<!-- START homeclassicmain REVOLUTION SLIDER 6.0.1 -->
        <rs-module-wrap id="rev_slider_1_1_wrapper" data-source="gallery" >
            <rs-module id="rev_slider_1_1" data-version="6.1.2" class="rev_slider_1_1_height">
                <rs-slides>
                    <rs-slide data-key="rs-1" data-title="Slide" data-thumb="https://via.placeholder.com/1920X705/888888.jpg" data-anim="ei:d;eo:d;s:d;r:0;t:zoomout;sl:d;">
                        <img src="https://via.placeholder.com/1920X705/888888.jpg" title="sliderbg-01" width="1920" height="705" class="rev-slidebg" data-no-retina>
                        <rs-layer
                            id="slider-1-slide-1-layer-1"
                            class="head-font" 
                            data-type="text"
                            data-rsp_ch="on"
                            data-xy="x:c;yo:263px,263px,159px,139px;"
                            data-text="w:normal;s:75,75,55,35;l:85,85,60,45;fw:600;"
                            data-frame_0="o:1;"
                            data-frame_0_chars="o:0;rX:-90deg;oZ:-50;"
                            data-frame_1="sp:900;"
                            data-frame_1_chars="e:Power4.easeInOut;d:10;oZ:-50;"
                            data-frame_999="o:0;st:w;sR:6600;"
                            >FARMING PRODUCTS 
                        </rs-layer>
                        <rs-layer
                            id="slider-1-slide-1-layer-2"
                            class="ttm-bgcolor-skincolor" 
                            data-type="text"
                            data-rsp_ch="on"
                            data-xy="x:c;yo:205px,205px,122px,106px;"
                            data-text="w:normal;s:30,30,20,17;l:30,30,18,17;fw:300;"
                            data-padding="t:7,7,5,3;r:25,25,16,10;b:7,7,5,3;l:25,25,16,10;"
                            data-frame_0="o:1;"
                            data-frame_0_chars="o:0;rX:-90deg;oZ:-50;"
                            data-frame_1="st:40;sp:700;sR:40;"
                            data-frame_1_chars="e:Power4.easeInOut;d:10;oZ:-50;"
                            data-frame_999="o:0;st:w;sR:7060;"
                            >Our High-Quality 
                        </rs-layer>
                        <rs-layer
                            id="slider-1-slide-1-layer-3" 
                            data-type="text"
                            data-color="#bababa"
                            data-rsp_ch="on"
                            data-xy="x:c;xo:0,0,0,-500px;yo:359px,359px,223px,112px;"
                            data-text="w:normal;s:17,17,14,11;l:24,24,19,15;a:center;"
                            data-dim="w:565px,565px,388px,239px;"
                            data-vbility="t,t,t,f"
                            data-frame_0="y:100%;"
                            data-frame_1="e:Linear.easeNone;st:1160;sp:500;sR:1160;"
                            data-frame_999="o:0;st:w;sR:7340;"
                            >Eco-friendly products are, the products that do not harm the environ- ment. whether in their production. 
                        </rs-layer>
                        <a
                            id="slider-1-slide-1-layer-4" 
                            class="rs-layer ttm-btn-bgcolor-skincolor ttm-btn ttm-btn-size-md"
                            href="#" target="_self" rel="nofollow"
                            data-type="text"
                            data-rsp_ch="on"
                            data-xy="x:c;yo:453px,453px,292px,205px;"
                            data-text="w:normal;s:15,15,12,12;l:15,15,12,12;fw:600;"
                            data-padding="t:16,16,12,12;r:35,35,25,25;b:16,16,12,12;l:35,35,25,25;"
                            data-frame_0="y:100%;"
                            data-frame_1="e:Linear.easeNone;st:1310;sp:500;sR:1310;"
                            data-frame_999="o:0;st:w;sR:7190;"
                            data-frame_hover="bgc:#232323;boc:#232323;bos:solid;bow:1px,1px,1px,1px;sp:300ms;"
                            >MORE ABOUT 
                        </a>
                        <rs-layer
                            id="slider-1-slide-1-layer-5"
                            class="ttm-bgcolor-white" 
                            data-type="shape"
                            data-rsp_ch="on"
                            data-xy="x:c;xo:-439px,-439px,-275px,-169px;yo:304px,304px,190px,117px;"
                            data-text="w:normal;s:20,20,12,7;l:0,0,15,9;"
                            data-dim="w:44px,44px,27px,16px;h:3px,3px,1px,1px;"
                            data-vbility="t,t,f,f"
                            data-frame_0="x:-50,-50,-31,-19;"
                            data-frame_1="e:Linear.easeNone;st:1030;sp:400;sR:1030;"
                            data-frame_999="o:0;st:w;sR:7570;"
                            > 
                        </rs-layer>
                        <rs-layer
                            id="slider-1-slide-1-layer-6"
                            class="ttm-bgcolor-white" 
                            data-type="shape"
                            data-rsp_ch="on"
                            data-xy="x:c;xo:441px,441px,276px,170px;yo:304px,304px,190px,117px;"
                            data-text="w:normal;s:20,20,12,7;l:0,0,15,9;"
                            data-dim="w:44px,44px,27px,16px;h:3px,3px,1px,1px;"
                            data-vbility="t,t,f,f"
                            data-frame_0="x:50,50,31,19;"
                            data-frame_1="e:Linear.easeNone;st:1570;sp:400;sR:1570;"
                            data-frame_999="o:0;st:w;sR:7030;"
                            > 
                        </rs-layer>
                    </rs-slide>
                    <rs-slide data-key="rs-2" data-title="Slide" data-thumb="https://via.placeholder.com/1920X705/888888.jpg" data-anim="ei:d;eo:d;s:d;r:0;t:zoomout;sl:d;">
                        <img src="https://via.placeholder.com/1920X705/888888.jpg" title="sliderbg-02" width="1920" height="705" class="rev-slidebg" data-no-retina>
                        <rs-layer
                            id="slider-1-slide-2-layer-1"
                            class="head-font" 
                            data-type="text"
                            data-rsp_ch="on"
                            data-xy="x:c;yo:263px,263px,159px,139px;"
                            data-text="w:normal;s:75,75,55,35;l:85,85,60,45;fw:600;"
                            data-frame_0="o:1;"
                            data-frame_0_chars="o:0;rX:-90deg;oZ:-50;"
                            data-frame_1="sp:900;"
                            data-frame_1_chars="e:Power4.easeInOut;d:10;oZ:-50;"
                            data-frame_999="o:0;st:w;sR:6600;"
                            >SOLAR AGRICULTURE 
                        </rs-layer>
                        <rs-layer
                            id="slider-1-slide-2-layer-2"
                            class="ttm-bgcolor-skincolor" 
                            data-type="text"
                            data-rsp_ch="on"
                            data-xy="x:c;yo:205px,205px,122px,106px;"
                            data-text="w:normal;s:30,30,20,17;l:30,30,18,17;fw:300;"
                            data-padding="t:7,7,5,3;r:25,25,16,10;b:7,7,5,3;l:25,25,16,10;"
                            data-frame_0="o:1;"
                            data-frame_0_chars="o:0;rX:-90deg;oZ:-50;"
                            data-frame_1="st:40;sp:700;sR:40;"
                            data-frame_1_chars="e:Power4.easeInOut;d:10;oZ:-50;"
                            data-frame_999="o:0;st:w;sR:7060;"
                            >World Program For 
                        </rs-layer>
                        <rs-layer
                            id="slider-1-slide-2-layer-3" 
                            data-type="text"
                            data-color="#bababa"
                            data-rsp_ch="on"
                            data-xy="x:c;xo:0,0,0,-500px;yo:359px,359px,223px,112px;"
                            data-text="w:normal;s:17,17,14,11;l:24,24,19,15;a:center;"
                            data-dim="w:565px,565px,388px,239px;"
                            data-vbility="t,t,t,f"
                            data-frame_0="y:100%;"
                            data-frame_1="e:Linear.easeNone;st:1160;sp:500;sR:1160;"
                            data-frame_999="o:0;st:w;sR:7340;"
                            >Eco-friendly products are, the products that do not harm the environ- ment. whether in their production. 
                        </rs-layer>
                        <a
                            id="slider-1-slide-2-layer-4" 
                            class="rs-layer ttm-btn-bgcolor-skincolor ttm-btn ttm-btn-size-md"
                            href="#" target="_self" rel="nofollow"
                            data-type="text"
                            data-rsp_ch="on"
                            data-xy="x:c;yo:453px,453px,292px,205px;"
                            data-text="w:normal;s:15,15,12,12;l:15,15,12,12;fw:600;"
                            data-padding="t:16,16,12,12;r:35,35,25,25;b:16,16,12,12;l:35,35,25,25;"
                            data-frame_0="y:100%;"
                            data-frame_1="e:Linear.easeNone;st:1310;sp:500;sR:1310;"
                            data-frame_999="o:0;st:w;sR:7190;"
                            data-frame_hover="bgc:#232323;boc:#232323;bos:solid;bow:1px,1px,1px,1px;sp:300ms;"
                            >REQUEST A QUOTE 
                        </a>
                        <rs-layer
                            id="slider-1-slide-2-layer-5"
                            class="ttm-bgcolor-white" 
                            data-type="shape"
                            data-rsp_ch="on"
                            data-xy="x:c;xo:-449px,-449px,-281px,-173px;yo:304px,304px,190px,117px;"
                            data-text="w:normal;s:20,20,12,7;l:0,0,15,9;"
                            data-dim="w:44px,44px,27px,16px;h:3px,3px,1px,1px;"
                            data-vbility="t,t,f,f"
                            data-frame_0="x:-50,-50,-31,-19;"
                            data-frame_1="e:Linear.easeNone;st:1030;sp:400;sR:1030;"
                            data-frame_999="o:0;st:w;sR:7570;"
                            > 
                        </rs-layer>
                        <rs-layer
                            id="slider-1-slide-2-layer-6"
                            class="ttm-bgcolor-white" 
                            data-type="shape"
                            data-rsp_ch="on"
                            data-xy="x:c;xo:451px,451px,282px,173px;yo:304px,304px,190px,117px;"
                            data-text="w:normal;s:20,20,12,7;l:0,0,15,9;"
                            data-dim="w:44px,44px,27px,16px;h:3px,3px,1px,1px;"
                            data-vbility="t,t,f,f"
                            data-frame_0="x:50,50,31,19;"
                            data-frame_1="e:Linear.easeNone;st:1570;sp:400;sR:1570;"
                            data-frame_999="o:0;st:w;sR:7030;"
                            > 
                        </rs-layer>
                    </rs-slide>
                </rs-slides>
            </rs-module>
        </rs-module-wrap>
        <!-- END REVOLUTION SLIDER -->
</template>
       

<script>
export default {
  name: "Slider",
  props: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>

